var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9526 32C10.6557 32 10.3588 31.835 10.1938 31.5711L1.61649 16.6928C1.51753 16.5278 1.41856 16.3629 1.31959 16.1979C1.31959 16.1649 1.2866 16.132 1.2866 16.132C0.428866 14.5155 0 12.767 0 10.9526C0 4.91546 4.91546 0 10.9526 0C16.9897 0 21.9052 4.91546 21.9052 10.9526C21.9052 12.734 21.4763 14.5155 20.6186 16.099C20.6186 16.132 20.5856 16.1649 20.5856 16.1649C20.4866 16.3299 20.3876 16.4948 20.2887 16.6928L11.7113 31.5711C11.5794 31.835 11.2825 32 10.9526 32ZM2.47423 15.5381C2.5732 15.7031 2.63918 15.868 2.73814 16L10.9526 30.2186L19.167 16C19.266 15.8351 19.3649 15.6701 19.4639 15.5052V15.4722C20.2227 14.0866 20.6186 12.5031 20.6186 10.9196C20.6186 5.64124 16.2969 1.31959 10.9526 1.31959C5.64124 1.31959 1.31959 5.64124 1.31959 10.9526C1.31959 12.5361 1.71546 14.1196 2.47423 15.5381C2.47423 15.5381 2.47423 15.5052 2.47423 15.5381Z",
    fill: "#3F6BAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9526 15.0763C8.18144 15.0763 5.90515 12.833 5.90515 10.0289C5.90515 7.25773 8.14845 4.98145 10.9526 4.98145C13.7237 4.98145 16 7.22474 16 10.0289C16 12.8 13.7237 15.0763 10.9526 15.0763ZM10.9526 6.33402C8.90721 6.33402 7.22474 7.98351 7.22474 10.0619C7.22474 12.1072 8.90721 13.7897 10.9526 13.7897C12.9979 13.7897 14.6804 12.1402 14.6804 10.0619C14.6804 7.98351 12.9979 6.33402 10.9526 6.33402Z",
    fill: "#3F6BAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6371 32H6.26807C5.90518 32 5.60828 31.7031 5.60828 31.3402C5.60828 30.9773 5.90518 30.6804 6.26807 30.6804H15.6371C16 30.6804 16.2969 30.9773 16.2969 31.3402C16.2969 31.7031 16 32 15.6371 32Z",
    fill: "#3F6BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.21698ad68ac1d2d7446b2715963f3cf6.svg";
export { ForwardRef as ReactComponent };